import { render, staticRenderFns } from "./sentiment.vue?vue&type=template&id=3c097722&scoped=true&"
import script from "./sentiment.vue?vue&type=script&lang=js&"
export * from "./sentiment.vue?vue&type=script&lang=js&"
import style0 from "./sentiment.vue?vue&type=style&index=0&id=3c097722&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c097722",
  null
  
)

export default component.exports